// import Vue from 'vue';
// import {i18n} from '../../I18n/index'
// import VueI18n from 'vue-i18n';
// const i18nNew = new VueI18n({
//     locale: 'pt-BR',
//     messages,
//   }); 
// Vue.prototype.$i18n = i18n;
// console.log(i18n)
// const { t } = i18n.global;
export default {
    state: {
        list: [],
        count: null,
        columnsToShow: [
            {
                id: "0",
                label: 'Nome',
                name: "nome",
                type: "Default",
                showing: true
            },
            {
                id: "1",
                label: "Sexo",
                name: "sexo",
                type: "Default",
                showing: true
            },
            {
                id: "2",
                label: "Data de Nascimento",
                name: "dataNascimento",
                type: "Default",
                showing: true
            },
            {
                id: "3",
                label: "E-mail",
                name: "email",
                type: "Default",
                showing: true
            },
            {
                id: "4",
                label: "Telefone",
                name: "telefone",
                type: "Default",
                showing: true
            }            
        ],
        columnsToShowAdmin: [
            {
                id: "0",
                label: "Nome",
                name: "nome",
                type: "Default",
                showing: true
            },
            {
                id: "1",
                label: "Sexo",
                name: "sexo",
                type: "Default",
                showing: true
            },
            {
                id: "2",
                label: "Data de Nascimento",
                name: "dataNascimento",
                type: "Default",
                showing: true
            },
            {
                id: "3",
                label: "E-mail",
                name: "email",
                type: "Default",
                showing: true
            },
            {
                id: "4",
                label: "Telefone",
                name: "telefone",
                type: "Default",
                showing: true
            }            
        ],
        view: "TABLE",
        colsPerPage: 4,
        filters: {
            search: "",
            orderBy: null,
            desc: true,

            date: {
                min: null,
                max: null,
            },
            access: {
                min: null,
                max: null,
            },
            devices: [],
            advertising: [],
            establishments: [],
            local: [],

            deviceName: "",

            usageTerms: [],
        },

        external: {
            filters: {
                filter: undefined,
                databaseId: undefined
            }
        }
    },

    mutations: {
        LEADS_SET_LIST(state, list) {
            state.list = list;
        },

        LEADS_SET_COUNT(state, count) {
            state.count = count;
        },

        LEADS_RESET_FILTER(state) {
            state.filters = {
                search: "",
                orderBy: null,
                desc: true,

                date: {
                    min: null,
                    max: null,
                },
                access: {
                    min: null,
                    max: null,
                },
                devices: [],
                advertising: [],
                establishments: [],
                local: [],

                deviceName: "",
            };

             state.external.filters = {
                filter: null,
                databaseId: null
            };
        },

        LEADS_SET_FILTER(state, { key, value }) {
            state.filters = {
                ...state.filters,
                [key]: value,
            };
        },

        LEADS_SET_EXTERNAL_FILTER(state, { key, value }) {
            state.external.filters = {
                ...state.external.filters,
                [key]: value,
            };
        },

        LEADS_SET_VIEW(state, view) {
            state.view = view;
        },

        LEADS_SET_COLS_PER_PAGE(state, colsPerPage) {
            state.colsPerPage = colsPerPage;
        },

        LEADS_SET_COLS_TO_SHOW(state, colsToShow) {
            state.columnsToShow = colsToShow
        },

        LEADS_SET_COLS_TO_SHOW_ADMIN(state, colsToShow) {
            state.columnsToShowAdmin = colsToShow
        },

        LEADS_RESET_COLS_TO_SHOW(state) {
            state.columnsToShow =
            [
                {
                    id: "0",
                    label: 'Nome',
                    name: "nome",
                    type: "Default",
                    showing: true
                },
                {
                    id: "1",
                    label: "Sexo",
                    name: "sexo",
                    type: "Default",
                    showing: true
                },
                {
                    id: "2",
                    label: "Data de Nascimento",
                    name: "dataNascimento",
                    type: "Default",
                    showing: true
                },
                {
                    id: "3",
                    label: "E-mail",
                    name: "email",
                    type: "Default",
                    showing: true
                },
                {
                    id: "4",
                    label: "Telefone",
                    name: "telefone",
                    type: "Default",
                    showing: true
                }            
            ]
        }
    },
};
